export default __webpack_public_path__ + "a0856d8585f2f8cfc9217b0b575dec72.mp3";